
export const privacidade = {
  hero: {
    label: 'Conformidade & Transparência',
    title: 'Política de Privacidade',
    subtitle: 'A FGT Capital respeita e protege os dados pessoais de seus clientes e visitantes, em conformidade com a Lei Geral de Proteção de Dados (LGPD – Lei nº 13.709/2018).',
    updated: 'Última atualização: janeiro de 2025'
  },
  lgpdBadge: 'Este documento está em conformidade com a Lei Geral de Proteção de Dados Pessoais (LGPD – Lei nº 13.709/2018) e com as diretrizes da Autoridade Nacional de Proteção de Dados (ANPD).',
  sections: [
    {
      title: 'Quem somos',
      content: [
        'A FGT Capital é uma empresa especializada em estruturação de decisões patrimoniais por meio de consórcios regulados, com sede em São Paulo/SP – Brasil.',
        'Para fins desta Política, a FGT Capital atua como Controladora dos dados pessoais coletados neste site e em suas interações com clientes e prospects.',
        'CNPJ e demais informações institucionais estão disponíveis mediante solicitação pelo canal de contato oficial.'
      ]
    },
    {
      title: 'Dados que coletamos',
      content: [
        'Coletamos apenas os dados estritamente necessários para a prestação dos nossos serviços e para o cumprimento de obrigações legais, incluindo:',
        '• Dados de identificação: nome completo, CPF/CNPJ (quando aplicável).',
        '• Dados de contato: e-mail, número de WhatsApp/telefone.',
        '• Dados financeiros e patrimoniais: faixa de valor de crédito, capacidade de parcela, horizonte de investimento — coletados exclusivamente no contexto do Diagnóstico Estratégico.',
        '• Dados de navegação: endereço IP, tipo de navegador, páginas visitadas e tempo de permanência, coletados de forma anonimizada via ferramentas de análise.',
        'Não coletamos dados sensíveis (origem racial, convicção religiosa, dado genético, biométrico, etc.) em nenhuma hipótese.'
      ]
    },
    {
      title: 'Finalidade e base legal do tratamento',
      content: [
        'Os dados coletados são tratados com as seguintes finalidades e bases legais previstas na LGPD:',
        '• Execução de contrato ou procedimentos preliminares (Art. 7º, V): para responder a solicitações, agendar diagnósticos e prestar os serviços contratados.',
        '• Legítimo interesse (Art. 7º, IX): para envio de comunicações relevantes sobre soluções patrimoniais, desde que o titular não se oponha.',
        '• Cumprimento de obrigação legal (Art. 7º, II): para atender exigências regulatórias do Banco Central do Brasil e demais órgãos competentes.',
        '• Consentimento (Art. 7º, I): para ações de marketing direto, quando solicitado explicitamente.'
      ]
    },
    {
      title: 'Compartilhamento de dados',
      content: [
        'A FGT Capital não vende, aluga ou cede dados pessoais a terceiros para fins comerciais próprios.',
        'Os dados poderão ser compartilhados exclusivamente com:',
        '• Administradoras de consórcio autorizadas pelo Banco Central do Brasil, para fins de análise e estruturação das operações.',
        '• Prestadores de serviços tecnológicos (hospedagem, CRM, e-mail transacional) que atuam como Operadores sob contrato de confidencialidade e conformidade com a LGPD.',
        '• Autoridades públicas, quando exigido por lei, ordem judicial ou regulamentação aplicável.',
        'Todos os parceiros e fornecedores são avaliados quanto à sua conformidade com a LGPD antes de qualquer compartilhamento de dados.'
      ]
    },
    {
      title: 'Retenção e exclusão de dados',
      content: [
        'Os dados pessoais são retidos pelo tempo necessário para cumprir as finalidades descritas nesta Política ou para atender obrigações legais e regulatórias.',
        '• Dados de prospects (não clientes): retidos por até 24 meses após o último contato, salvo solicitação de exclusão anterior.',
        '• Dados de clientes: retidos pelo prazo contratual acrescido de 5 anos, conforme exigências do Banco Central e legislação tributária.',
        'Após o prazo de retenção, os dados são eliminados de forma segura ou anonimizados, impossibilitando a identificação do titular.'
      ]
    },
    {
      title: 'Segurança da informação',
      content: [
        'Adotamos medidas técnicas e organizacionais adequadas para proteger os dados pessoais contra acesso não autorizado, perda, alteração ou divulgação indevida, incluindo:',
        '• Criptografia de dados em trânsito (TLS/HTTPS) e em repouso.',
        '• Controle de acesso baseado em função (RBAC), com princípio do menor privilégio.',
        '• Monitoramento contínuo de acessos e incidentes de segurança.',
        '• Treinamento periódico da equipe sobre boas práticas de proteção de dados.',
        'Em caso de incidente de segurança que possa acarretar risco ou dano relevante aos titulares, a ANPD e os afetados serão notificados nos prazos legais.'
      ]
    },
    {
      title: 'Direitos dos titulares',
      content: [
        'Nos termos da LGPD (Art. 18), você tem os seguintes direitos em relação aos seus dados pessoais:',
        '• Confirmação e acesso: saber se tratamos seus dados e obter cópia deles.',
        '• Correção: solicitar a atualização de dados incompletos, inexatos ou desatualizados.',
        '• Anonimização, bloqueio ou eliminação: de dados desnecessários, excessivos ou tratados em desconformidade.',
        '• Portabilidade: receber seus dados em formato estruturado para transferência a outro fornecedor.',
        '• Revogação do consentimento: a qualquer momento, sem prejuízo da licitude do tratamento anterior.',
        '• Oposição: ao tratamento realizado com base em legítimo interesse, quando não justificado.',
        'Para exercer qualquer direito, entre em contato pelo e-mail contato@fgt-capital.com ou pelo WhatsApp +55 11 93032-2408. Responderemos em até 15 dias úteis.'
      ]
    },
    {
      title: 'Cookies e tecnologias de rastreamento',
      content: [
        'Utilizamos cookies e tecnologias similares para melhorar a experiência de navegação, analisar o tráfego e personalizar conteúdos.',
        '• Cookies essenciais: necessários para o funcionamento básico do site. Não podem ser desativados.',
        '• Cookies analíticos: coletam informações anonimizadas sobre o uso do site (ex.: Google Analytics). Podem ser recusados.',
        '• Cookies de marketing: utilizados para exibir conteúdos relevantes. Ativados apenas com consentimento explícito.',
        'Você pode gerenciar suas preferências de cookies a qualquer momento pelas configurações do seu navegador.'
      ]
    },
    {
      title: 'Alterações nesta Política',
      content: [
        'Esta Política pode ser atualizada periodicamente para refletir mudanças em nossas práticas, na legislação aplicável ou em determinações da ANPD.',
        'Alterações relevantes serão comunicadas por e-mail (para titulares cadastrados) e/ou por aviso destacado neste site.',
        'A data da última atualização está indicada no topo desta página. O uso continuado do site após a publicação de alterações implica a aceitação da Política revisada.'
      ]
    }
  ],
  dpo: {
    title: 'Encarregado de Dados (DPO)',
    description: 'Para exercer seus direitos, esclarecer dúvidas sobre esta Política ou reportar qualquer questão relacionada ao tratamento de dados pessoais, entre em contato com nosso Encarregado de Proteção de Dados:'
  },
  cta: {
    title: 'Transparência é parte do nosso método',
    subtitle: 'Tratamos seus dados com o mesmo rigor que aplicamos às decisões patrimoniais dos nossos clientes. Agende um Diagnóstico Estratégico e conheça nossa abordagem.',
    primary: 'Agendar Diagnóstico Estratégico',
    secondary: 'Falar com a Equipe'
  }
};
